import * as React from 'react';
import styles from './Placeholder.module.scss';

export const Placeholder = (): JSX.Element => {
  return <div className={styles.Placeholder}></div>;
};
